module.exports = __webpack_public_path__ + "img/cover.4060e8a1.jpg";